import { useState, useMemo, useEffect } from 'react';
import {
    Card,
    CardBody,
    CardHeader,
    Dialog, DialogBody,
    Typography,
} from "@material-tailwind/react";
import { ClockLoader } from 'react-spinners';
import TimeRangeGrid from '../../components/time-range-grid';
import { useNavigate, useParams } from 'react-router-dom';
import { useUserContext } from '../../context';
import { useApi } from '../../hooks/useApi';

export default function AdvanceBookingsDay() {
    let { selectedDate } = useParams();
    const navigate = useNavigate();
    const { fetchAccessToken, defaultHotel, isAdmin } = useUserContext();
    const [isLoading, setIsLoading] = useState(false);
    const { getBookings } = useApi();
    const [bookings, setBookings] = useState([]);
    selectedDate = selectedDate ? new Date(selectedDate) : getCurrentDate();
    const selectedDateString = formatDate(selectedDate);

    useEffect(() => {
        let getBookingsInternal = async () => {
            if (!defaultHotel || !selectedDateString) {
                return;
            }
            setIsLoading(true);
            try {
                const accessToken = await fetchAccessToken();
                const startTime = getEpoch(selectedDate, "00:00");
                const endTime = getEpoch(selectedDate, "23:59");
                const data = await getBookings(defaultHotel, startTime, endTime, accessToken);
                if (data && data.length) {
                    setBookings(data);
                }
                else {
                    setBookings([]);
                }
            } catch (error) {
                console.error(error);
            }
            finally {
                setIsLoading(false);
            }
        }

        if (defaultHotel) {
            getBookingsInternal();
        }
    }, [defaultHotel, selectedDateString]);


    function getCurrentDate(daysAdd = 0) {
        let d = new Date();
        d.setDate(d.getDate() + daysAdd);
        d.setHours(0, 0, 0, 0)
        return d;
    }

    function formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    function getEpoch(date, time, seconds = 0) {
        const [hours, minutes] = time.split(':').map(Number);
        const combinedDate = new Date(date);
        combinedDate.setHours(hours);
        combinedDate.setMinutes(minutes);
        combinedDate.setSeconds(seconds);
        combinedDate.setMilliseconds(seconds * 100);

        return combinedDate.getTime();
    }

    const timeRanges = useMemo(() => {
        const startTime = getEpoch(selectedDate, "00:00");
        const endTime = getEpoch(selectedDate, "23:59");

        return bookings.map(booking => ({
            start: calculateStartHours(booking.checkInEpoch, startTime),
            end: calculateEndHours(booking.checkOutEpoch, endTime),
            booking
        }));
    }, [bookings]);


    function calculateStartHours(apiEpoch, localEpoch) {
        if (apiEpoch <= localEpoch) {
            return 0;
        }
        const apiEpochInSeconds = apiEpoch / 1000;
        const localEpochInSeconds = localEpoch / 1000;
        const differenceInSeconds = apiEpochInSeconds - localEpochInSeconds;
        const differenceInHours = Math.floor(differenceInSeconds / 3600);

        return differenceInHours;
    }

    function calculateEndHours(apiEpoch, localEpoch) {
        if (apiEpoch >= localEpoch) {
            return 24;
        }
        const apiEpochInSeconds = apiEpoch / 1000;
        const localEpochInSeconds = localEpoch / 1000;
        const differenceInSeconds = localEpochInSeconds - apiEpochInSeconds;
        const differenceInHours = Math.floor(differenceInSeconds / 3600);

        return 24 - differenceInHours;
    }

    let gotoPreviousDate = () => {
        const yesterday = new Date(selectedDate);
        yesterday.setDate(selectedDate.getDate() - 1);
        const year = yesterday.getFullYear();
        const month = String(yesterday.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
        const dayOfMonth = String(yesterday.getDate()).padStart(2, '0');
        let date = `${year}-${month}-${dayOfMonth}`;
        navigate(`/manager/bookings/${date}`);
    }

    let gotonextDate = () => {
        const yesterday = new Date(selectedDate);
        yesterday.setDate(selectedDate.getDate() + 1);
        const year = yesterday.getFullYear();
        const month = String(yesterday.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
        const dayOfMonth = String(yesterday.getDate()).padStart(2, '0');
        let date = `${year}-${month}-${dayOfMonth}`;
        navigate(`/manager/bookings/${date}`);
    }

    return (
        <div>
            <Card className="h-full w-full">
                <CardHeader variant="gradient" color="gray" className="mt-3 mb-3 p-3 flex flex-row justify-between">
                    <Typography variant="h6" color="white">
                        Advanced Bookings for {selectedDateString}
                    </Typography>
                </CardHeader>
                <CardBody className="overflow-scroll px-3 pt-2 pb-2">
                    <div className="flex items-center mb-4">
                        <Typography variant="h6" color="black">
                            Total Entries: {bookings.length}
                        </Typography>

                    </div>
                    <div className="flex justify-between items-center mb-4">
                        <button onClick={gotoPreviousDate} className="ml-2 p-1 bg-green-300 rounded hover:bg-green-500">
                            {"<<<"}
                        </button>
                        <button onClick={gotonextDate} className="m-1 p-1 bg-green-300 rounded hover:bg-green-500">
                            {">>>"}
                        </button>
                    </div>
                    <TimeRangeGrid timeRanges={timeRanges} isAdmin={isAdmin} />
                </CardBody>
            </Card>
            <Dialog open={isLoading} className="bg-transparent shadow-none" size="md">
                <DialogBody className="bg-transparent shadow-none flex justify-center">
                    <ClockLoader color="#2be60d" />
                </DialogBody>
            </Dialog>
        </div>
    );
}

